import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabserviceinmumbai() {



  const cardData =
  {
    keyword: 'Best Cab Service in Mumbai ',
    heading: 'Shambhu Cabs: Best Cab Service in Mumbai',
    headingDescription: 'Shambhu Cabs offers the Best Cab Service in Mumbai, delivering safe, comfortable, and reliable transportation for families, corporate travelers, tourists, and daily commuters across the city. Our fleet of well-maintained hatchbacks, sedans, SUVs, luxury cars, and tempo travellers ensures smooth travel for airport transfers, office commutes, Mumbai Darshan, hotel pickups, and outstation journeys. With professional chauffeurs, flexible one-way and round-trip options, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs provides a seamless and stress-free travel experience. For punctuality, comfort, and trusted service, Shambhu Cabs stands out as the best cab service in Mumbai.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s iconic stone arch constructed to honor the visit of King George V and Queen Mary. Overlooking the Arabian Sea, the monument stands as a grand symbol of colonial heritage. Tourists enjoy ferry rides to Elephanta Island, coastal photography, and the bustling street market nearby. Evenings at the Gateway are magical, with soft lighting, sea breeze, and a lively atmosphere created by performers, food vendors, and travelers from around the world."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive is Mumbai’s stunning 3.6 km-long curved boulevard along the Arabian Sea. The street lights at night resemble a 'Queen’s Necklace,' making it one of the most beautiful coastlines in India. Ideal for morning walks, jogging, cycling, and sunset viewing, Marine Drive offers a peaceful escape from city life. The Art Deco buildings lining the road add heritage value, forming one of the world’s largest Art Deco collections. The sea breeze, scenic views, and relaxing vibe make it a must-visit."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT is a UNESCO World Heritage Site and an architectural masterpiece built in 1887. A blend of Victorian Gothic Revival and traditional Indian styles, its grand domes, stained glass windows, carvings, and high arches attract architecture and history lovers. One of India’s busiest railway stations, it stands as a symbol of Mumbai’s bustling life. At night, the building is illuminated beautifully, making it one of the most photographed landmarks in the city."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beachfront, famous for its lively atmosphere, delicious street food, and colorful sunsets. Visitors enjoy local favorites like pav bhaji, pani puri, bhel puri, and ice gola. Kids love camel rides, horse rides, and kite flying, while Bollywood fans often spot celebrities who live nearby. The energetic yet relaxing ambiance makes Juhu Beach a perfect place for evening strolls, photography, and enjoying Mumbai’s coastal charm."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shree Siddhivinayak Temple in Prabhadevi is one of India’s most revered Ganesha temples, known for fulfilling wishes. The wooden doors feature Ashtavinayak carvings, and the gold-plated inner sanctum adds to its divine aura. Thousands visit daily, including film stars, sports personalities, and political leaders. During Ganesh Chaturthi, the temple area transforms into a vibrant cultural and devotional celebration filled with music, lights, chants, and festive energy."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, situated on a tiny islet connected by a narrow causeway, is one of Mumbai’s most spiritual and picturesque landmarks. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it showcases Indo-Islamic architecture with its stunning white marble structure. Visitors walk along the pathway during low tide to reach the dargah. The peaceful ambiance, soulful qawwalis, and panoramic sea views make it a deeply moving experience for people of all faiths."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, located on Elephanta Island, are ancient rock-cut caves and a UNESCO World Heritage Site dating back to the 5th–8th centuries. Dedicated mainly to Lord Shiva, the caves feature breathtaking sculptures such as the Trimurti (three-faced Shiva), Nataraja, and various mythological carvings. Visitors take a ferry from the Gateway of India, enjoying sea views, monkeys, local food stalls, and a peaceful island atmosphere filled with history and art."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is an iconic cable-stayed bridge connecting Mumbai’s western suburbs to South Mumbai. It is celebrated for its modern engineering, graceful architecture, and stunning views of the sea and skyline. The bridge reduces travel time and offers breathtaking sights during sunrise, sunset, and nighttime when the structure glows with lights. Although stopping on the bridge isn’t allowed, it remains a favorite landmark for photographers and travelers."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar is one of India’s oldest and most fascinating flea markets, known for antiques, vintage décor, Bollywood posters, gramophones, lamps, furniture, cameras, and rare collectibles. Every visit feels like a treasure hunt, with lanes filled with quirky items and historical remnants. The market attracts photographers, designers, and collectors seeking unique artifacts. It offers a glimpse into Mumbai’s old charm, trade culture, and hidden stories from the past."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread over 100 square kilometers, Sanjay Gandhi National Park is a lush green paradise within Mumbai. Home to leopards, deer, birds, butterflies, and ancient Kanheri Caves, the park offers nature trails, cycling routes, boating, safari rides, and scenic viewpoints. The Kanheri Caves, carved out of basalt rock, feature Buddhist sculptures, meditation halls, and monasteries dating back thousands of years. The park serves as a peaceful escape from the busy city."
  },
  {
    "title": "Mount Mary Church",
    "description": "Mount Mary Basilica, located in Bandra, is one of Mumbai’s oldest and most beautiful Roman Catholic churches. Built in stunning Gothic style, it overlooks the sea and offers a calm, spiritual environment. The annual Bandra Fair brings thousands of visitors who enjoy food stalls, festivities, and cultural performances. The church is a symbol of faith, unity, and Mumbai’s diverse religious culture."
  }
],



"services": [
  {
    "name": "Best Taxi Service Mumbai",
    "description": "Best Taxi Service Mumbai offers top-rated, professional, and highly reliable taxi solutions across the entire city. With well-trained chauffeurs, clean AC cars, and consistent service quality, this taxi service is ideal for daily travel, airport transfers, sightseeing, and long-distance rides. Customers receive transparent pricing, quick response times, and seamless booking options. The service ensures comfortable city rides, safe night travel, and dependable transportation even during peak hours. Designed to deliver maximum comfort, punctuality, and customer satisfaction."
  },
  {
    "name": "Top Cab Companies Mumbai",
    "description": "Top Cab Companies Mumbai represent the most trusted and verified taxi operators offering high-quality cab services for local and outstation travel. These companies ensure well-maintained vehicles, professional drivers, punctual pickups, and efficient customer support. Whether you need long distance travel, a city ride, corporate transportation, or airport transfers, these top operators deliver smooth and dependable cab services with flexible booking and transparent fares."
  },
  {
    "name": "Reliable Cab Service Mumbai",
    "description": "Reliable Cab Service Mumbai provides consistently dependable transportation with an emphasis on safety, hygiene, punctuality, and professional driving standards. Each ride includes clean AC cars, polite drivers, and assured on-time arrivals. The service is perfect for office commutes, family travel, medical appointments, corporate visits, and anytime mobility across Mumbai. With round-the-clock availability and transparent fare structures, passengers can count on trustworthy travel every time."
  },
  {
    "name": "Affordable Cab Service Mumbai",
    "description": "Affordable Cab Service Mumbai offers budget-friendly travel options without compromising on comfort or safety. The service includes economical sedans, hatchbacks, and SUVs for short and long routes. Ideal for students, office commuters, tourists, and families looking for value-for-money rides, it features transparent pricing, clean vehicles, and trained chauffeurs. Passengers enjoy low-cost, high-quality travel throughout the city and suburbs."
  },
  {
    "name": "Trusted Taxi Mumbai",
    "description": "Trusted Taxi Mumbai delivers safe and dependable travel experiences with experienced drivers, verified backgrounds, and clean, well-kept vehicles. Designed for local, airport, and outstation travel, this service ensures quick availability, comfortable rides, and consistent service standards. Passengers prefer it for reliability, professionalism, and strong customer satisfaction."
  },
  {
    "name": "Mumbai Best Chauffeur Service",
    "description": "Mumbai Best Chauffeur Service provides premium driver-based travel with professionally trained chauffeurs skilled in city routes, etiquette, safety protocols, and customer care. This service is ideal for corporate executives, VIP clients, luxury travel, special events, and long-distance journeys. It offers a refined travel experience with smooth driving, well-dressed chauffeurs, high-comfort AC vehicles, and exceptional service quality."
  },
  {
    "name": "Premium Cab Service Mumbai",
    "description": "Premium Cab Service Mumbai offers luxurious rides in high-end sedans and SUVs with exceptional comfort, leather interiors, silent cabins, and professionally trained chauffeurs. Ideal for business meetings, airport pickups, weddings, and VIP guests, this service provides a superior travel experience. Customers benefit from punctual pickup, immaculate cars, privacy, and courteous drivers."
  },
  {
    "name": "Mumbai City Cab Booking",
    "description": "Mumbai City Cab Booking offers convenient and instant booking for short-distance, local, and point-to-point travel across the city. This service delivers fast rides, GPS-enabled vehicles, and reliable drivers for smooth mobility across busy roads and crowded business hubs. Ideal for shopping trips, office visits, doctor appointments, and daily travel within Mumbai."
  },
  {
    "name": "Best Local Taxi Mumbai",
    "description": "Best Local Taxi Mumbai provides comfortable and affordable rides within the city with quick availability and efficient navigation through Mumbai traffic. The service is perfect for household travel, college students, office goers, and senior citizens who require safe and nearby taxi access. Clean AC cars and trusted drivers ensure stress-free local commuting."
  },
  {
    "name": "24x7 Cab Service Mumbai",
    "description": "24x7 Cab Service Mumbai ensures round-the-clock transportation with fast response times for early-morning flights, late-night emergencies, or routine daily travel. The service offers safe night travel, reliable drivers, quick pickup, and continuous availability across all locations in Mumbai. Perfect for airport trips, urgent travel, and unexpected ride needs."
  },
  {
    "name": "Mumbai Outstation Best Cab",
    "description": "Mumbai Outstation Best Cab delivers premium outstation travel with highway-trained chauffeurs, comfortable cars, and safe long-distance driving. Ideal for one-way, round trips, weekend getaways, business travel, and multi-city tours. Customers can choose sedans, SUVs, and premium vehicles based on travel requirements. The service guarantees comfort, reliability, and smooth long-route travel."
  },
  {
    "name": "Safe Taxi Service Mumbai",
    "description": "Safe Taxi Service Mumbai focuses on secure travel with verified drivers, sanitized cars, GPS tracking, and strict safety protocols. Suitable for families, women travelers, senior citizens, children, and corporate clients, the service ensures tension-free commuting. Every ride offers comfort, confidence, and peace of mind with safety-first practices."
  },
  {
    "name": "Mumbai Sedan Cab Best",
    "description": "Mumbai Sedan Cab Best provides comfortable, fuel-efficient, and affordable sedan rides ideal for daily commuting, office travel, airport transfers, and outstation journeys. Sedans offer excellent legroom, smooth driving, and stable rides. Popular choices include Dzire, Etios, and Honda City—perfect for both city and long-distance travel."
  },
  {
    "name": "Mumbai SUV Cab Service",
    "description": "Mumbai SUV Cab Service offers spacious and powerful SUVs such as Ertiga, Innova, and Crysta for family trips, group travel, airport rides, and outstation journeys. With larger seating capacity, superior comfort, and excellent performance, SUV cabs are ideal for long routes and highway driving. Perfect for families, tourists, and corporate groups."
  },
  {
    "name": "Best Airport Cab Mumbai",
    "description": "Best Airport Cab Mumbai provides punctual and easy airport pickups and drops for T1 and T2 terminals. With trained chauffeurs, ample luggage space, real-time flight monitoring, and 24×7 availability, this service ensures smooth and stress-free airport travel. Preferred by business travellers, families, and frequent flyers."
  },
  {
    "name": "Corporate Best Cabs Mumbai",
    "description": "Corporate Best Cabs Mumbai offers efficient and professional transportation solutions for companies, IT parks, business teams, and executives. Services include staff shuttles, corporate events transport, airport transfers, executive sedans, and monthly billing support. Designed for reliability, punctuality, and high-quality chauffeur service."
  },
  {
    "name": "Best AC Taxi Mumbai",
    "description": "Best AC Taxi Mumbai provides clean, cool, and comfortable AC rides across the city, ideal for summer heat, long journeys, and business travel. The service ensures sanitized interiors, smooth driving, and quick availability. Perfect for daily commuting, tourists, and corporate passengers needing comfortable travel."
  },
  {
    "name": "Fast Cab Service Mumbai",
    "description": "Fast Cab Service Mumbai delivers quick cab dispatch, short waiting times, and smooth last-minute ride availability. Ideal for urgent commutes, office travel, hospital visits, and any immediate travel need. With fast pickup and well-connected drivers, customers experience quick and hassle-free city travel."
  }
],

"tableData": [
  ["Best Taxi Service Mumbai", "Top Cab Companies Mumbai"],
  ["Reliable Cab Service Mumbai", "Affordable Cab Service Mumbai"],
  ["Trusted Taxi Mumbai", "Mumbai Best Chauffeur Service"],
  ["Premium Cab Service Mumbai", "Mumbai City Cab Booking"],
  ["Best Local Taxi Mumbai", "24x7 Cab Service Mumbai"],
  ["Mumbai Outstation Best Cab", "Safe Taxi Service Mumbai"],
  ["Mumbai Sedan Cab Best", "Mumbai SUV Cab Service"],
  ["Best Airport Cab Mumbai", "Corporate Best Cabs Mumbai"],
  ["Best AC Taxi Mumbai", "Fast Cab Service Mumbai"]
],


"whychoose": [
  {
    "WhyChooseheading": "Best Cab Service in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs is known for providing the best cab service in Mumbai, offering safe, reliable, and comfortable travel for daily commutes, airport transfers, and outstation trips."
  },
  {
    "WhyChooseheading": "Top-Quality and Well-Maintained Vehicles",
    "WhyChoosedescription": "Our fleet includes clean, air-conditioned, and regularly serviced vehicles to give you a premium and comfortable travel experience across Mumbai."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "We have highly skilled drivers who know Mumbai’s routes well, ensuring smooth, safe, and timely travel for every trip."
  },
  {
    "WhyChooseheading": "Honest and Transparent Pricing",
    "WhyChoosedescription": "Enjoy clear and upfront pricing with no hidden charges, making Shambhu Cabs one of the most trusted cab services in Mumbai."
  },
  {
    "WhyChooseheading": "24/7 Assistance and Support",
    "WhyChoosedescription": "Our customer support team is available around the clock to assist you with bookings, queries, and last-minute travel needs."
  },
  {
    "WhyChooseheading": "Flexible Travel Options",
    "WhyChoosedescription": "Choose from hourly rentals, full-day cabs, airport transfers, corporate travel, and outstation packages designed to suit your needs."
  },
  {
    "WhyChooseheading": "Sanitized and Safe Vehicles",
    "WhyChoosedescription": "All vehicles are sanitized before every trip, ensuring a clean, safe, and hygienic travel experience for passengers."
  },
  {
    "WhyChooseheading": "Punctual and Reliable Service",
    "WhyChoosedescription": "We ensure on-time pickups and dependable service, making your travel experience smooth, hassle-free, and truly the best in Mumbai."
  }
]
























  }

const faqData = [
  {
    question: 'Is Shambhu Cabs the best cab service in Mumbai?',
    answer: 'Yes, Shambhu Cabs is known for offering the best cab service in Mumbai. We provide reliable, comfortable, and affordable rides for both local and outstation travel.',
  },
  {
    question: 'How can I book the best cab service in Mumbai with Shambhu Cabs?',
    answer: 'You can easily book the best cab service in Mumbai through our website, mobile app, or by calling our 24x7 customer support team for assistance.',
  },
  {
    question: 'What makes Shambhu Cabs the best choice for cab services in Mumbai?',
    answer: 'Shambhu Cabs stands out for its prompt service, clean and well-maintained vehicles, experienced drivers, and commitment to customer satisfaction, making us the best cab service in Mumbai.',
  },
  {
    question: 'Are the drivers experienced for the best cab service in Mumbai?',
    answer: 'Yes, all our drivers are professional, licensed, and familiar with Mumbai’s routes to ensure a smooth, safe, and comfortable ride.',
  },
  {
    question: 'Can I customize my pickup and drop-off locations with Shambhu Cabs?',
    answer: 'Absolutely. You can specify your preferred pickup and drop-off locations anywhere in Mumbai to make your journey as convenient as possible.',
  },
  {
    question: 'Is the best cab service in Mumbai available 24x7?',
    answer: 'Yes, Shambhu Cabs offers 24x7 cab services across Mumbai, so you can book a ride whenever you need it.',
  },
  {
    question: 'Are safety and hygiene protocols followed for the best cab service in Mumbai?',
    answer: 'Yes, all vehicles are sanitized regularly, and our drivers adhere to strict hygiene and safety protocols to ensure your well-being during the journey.',
  },
  {
    question: 'What payment options are available for booking the best cab service in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments for all cab bookings in Mumbai.',
  },
  {
    question: 'Is customer support available during my ride with the best cab service in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your journey, ensuring a smooth and enjoyable experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Abhishek Mehta',
    feedback: 'Shambhu Cabs is by far the best cab service I’ve used in Mumbai. Prompt service, great drivers, and comfortable rides make them my go-to choice.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Joshi',
    feedback: 'I had an amazing experience with Shambhu Cabs. The driver was professional, and the car was clean and comfortable. Highly recommended!',
    rating: 5,
  },
];








































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Best Cab Service in Mumbai",
  "image": "https://www.shambhucab.com/assets/images/best-cab-service-mumbai.jpg",
  "description": "Shambhu Cabs provides the best cab service in Mumbai, offering reliable, affordable, and premium local, airport, outstation, sedan, and SUV taxi services, available 24×7.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "1800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/best-cab-service-mumbai"
  }
};




  return (
    <div>
<Helmet>
  <title>Best Cab Service in Mumbai | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book the best cab service in Mumbai with Shambhu Cabs. Reliable, affordable, and premium local, airport, outstation, sedan, and SUV cab services available 24×7."
  />

  <meta
    name="keywords"
    content="Best Taxi Service Mumbai, Top Cab Companies Mumbai, Reliable Cab Service Mumbai, Affordable Cab Service Mumbai, Trusted Taxi Mumbai, Mumbai Best Chauffeur Service, Premium Cab Service Mumbai, Mumbai City Cab Booking, Best Local Taxi Mumbai, 24x7 Cab Service Mumbai, Mumbai Outstation Best Cab, Safe Taxi Service Mumbai, Mumbai Sedan Cab Best, Mumbai SUV Cab Service, Best Airport Cab Mumbai, Corporate Best Cabs Mumbai, Best AC Taxi Mumbai, Fast Cab Service Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/57.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bestcabserviceinmumbai;